/**
 * Action type to store the room start time from the API.
 */
export const SET_ROOM_START_TIME = 'SET_ROOM_START_TIME';
/**
 * Action type to clear the room time limit state (on conference leave).
 */
export const CLEAR_ROOM_TIME_LIMIT = 'CLEAR_ROOM_TIME_LIMIT';
/**
 * Action type to mark that the warning has been shown.
 */
export const SET_TIME_LIMIT_WARNING_SHOWN = 'SET_TIME_LIMIT_WARNING_SHOWN';
/**
 * Action type to show the warning notification.
 */
export const SHOW_ROOM_TIME_LIMIT_WARNING = 'SHOW_ROOM_TIME_LIMIT_WARNING';
/**
 * Action type to hide the warning notification.
 */
export const HIDE_ROOM_TIME_LIMIT_WARNING = 'HIDE_ROOM_TIME_LIMIT_WARNING';
/**
 * Action type to show the final countdown.
 */
export const SHOW_FINAL_COUNTDOWN = 'SHOW_FINAL_COUNTDOWN';
/**
 * Action type to hide the final countdown.
 */
export const HIDE_FINAL_COUNTDOWN = 'HIDE_FINAL_COUNTDOWN';
/**
 * Action type to update countdown seconds.
 */
export const UPDATE_COUNTDOWN_SECONDS = 'UPDATE_COUNTDOWN_SECONDS';
